<app-block-wrapper [_editable]="_editable" [style]="style">
  <ndc-dynamic
    *ngFor="let blok of blocks; trackBy: trackByFunction"
    [ndcDynamicComponent]="components[blok.component]"
    [ndcDynamicInputs]="$any(blok)"
  ></ndc-dynamic>
</app-block-wrapper>
